import common from './common'
const uploadCsvButtonLabel = 'Upload Csv'
const downloadCsvTemplateButtonLabel = 'Template Csv'
const uploadCsvLabelDataTypeCustomerDetail = 'Customer detail'
const uploadCsvLabelDataTypeCustomerPriceCustom = 'Customer custom price'
const uploadCsvLabelDataTypeCustomerPriceFix = 'Customer fix price'
const uploadCsvLabelDataTypeTransporterDetail = 'Rekanan 3PL detail'
const uploadCsvLabelDataTypeTransporterPriceCustom = 'Rekanan 3PL custom price'
const uploadCsvLabelDataTypeTransporterPriceFix = 'Rekanan 3PL fix price'
const uploadCsvLabelDataTypeCategory = 'Kategori'
const uploadCsvLabelDataTypeTransportType = 'Tipe Kendaraan'
const uploadCsvLabelDataTypeCostOption = 'Pilihan biaya Tambahan'
const uploadCsvLabelDataTypeOriginOption = 'Keterangan lokasi asal'
const uploadCsvLabelDataTypeDestinationOption = 'Keterangan lokasi tujuan'
const uploadCsvLabelDataTypeCancelOption = 'Alasan pembatalan'
const uploadCsvLabelDataTypeAccidentOption = 'Keterangan kecelakaan'
const uploadCsvLabelDataTypeLocation = 'Lokasi'
const uploadedCsvDataStatusListButton = 'Status data yang diupload'
const uploadedCsvDataStatusListDialogTitle = 'Status data yang telah diunggah'
const uploadedCsvDataDetailListDialogTitle = 'Detail data yang telah diunggah'
const uploadCsvSuccessMessage = 'Berhasil meng-unggah file, data akan segera di proses'
const csvListTableUploaderColumnLabel = 'Diunggah oleh'
const csvListTableUploadedAtColumnLabel = 'Diunggah pada'
const csvListTableStatusColumnLabel = 'Status proses'
const csvListTableSuccessRecordCountColumnLabel = 'Sukses'
const csvListTableFailedRecordCountColumnLabel = 'Gagal'
const csvListTablePagination = (page, length, size, totalEntry) => common.commonTablePagination(page, length, size, totalEntry)

export default {
  uploadCsvButtonLabel,
  downloadCsvTemplateButtonLabel,
  uploadCsvLabelDataTypeCustomerDetail,
  uploadCsvLabelDataTypeCustomerPriceCustom,
  uploadCsvLabelDataTypeCustomerPriceFix,
  uploadCsvLabelDataTypeTransporterDetail,
  uploadCsvLabelDataTypeTransporterPriceCustom,
  uploadCsvLabelDataTypeTransporterPriceFix,
  uploadCsvLabelDataTypeCategory,
  uploadCsvLabelDataTypeTransportType,
  uploadCsvLabelDataTypeCostOption,
  uploadCsvLabelDataTypeOriginOption,
  uploadCsvLabelDataTypeDestinationOption,
  uploadCsvLabelDataTypeCancelOption,
  uploadCsvLabelDataTypeAccidentOption,
  uploadCsvLabelDataTypeLocation,
  uploadedCsvDataStatusListButton,
  uploadedCsvDataStatusListDialogTitle,
  uploadedCsvDataDetailListDialogTitle,
  uploadCsvSuccessMessage,
  csvListTableUploaderColumnLabel,
  csvListTableUploadedAtColumnLabel,
  csvListTableStatusColumnLabel,
  csvListTablePagination,
  csvListTableSuccessRecordCountColumnLabel,
  csvListTableFailedRecordCountColumnLabel,
}
